import axios from 'axios'

export default {
    initialize: function () {
        window.ptId = getPtId()
        window.clientId = parseInt(getParamValue('client_id'))
        window.openedByApp = getParamValue('app')
        window.language = getLanguage()
        window.apiDev = getParamValue('dev')
        window.appVersion = getParamValue('app_version')
        window.configType = getParamValue('type')
        window.appReceiveData = getParamValue('receive_data')
        window.bookingScheduleId = getParamValue('booking_schedule_id')
        window.bookingDate = getParamValue('booking_date')
        window.filteredPacks = getFilteredPacks()
        window.showOnlyKlarnaPacks = getParamValue('klarna')
        window.screenBackgroundColor = getParamValue('screen_background')
        window.screenBackgroundColor = window.screenBackgroundColor ? window.screenBackgroundColor : getParamValue('background')
        window.apiKey = getApiKey()
        checkBackground()

        if (window.openedByApp == 'true') {
            window.openedByApp = true
        } else {
            window.openedByApp = false
        }

        function getParamValue(param) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            return urlParams.get(param)
        }

        function getPtId() {
            const ptId = getParamValue('pt_id')
            const pt = getParamValue('pt')
            if (ptId) {
                return parseInt(ptId)
            }
            if (pt) {
                if (PTS_IDS && PTS_IDS[pt]) {
                    return PTS_IDS[pt]
                } else {
                    return pt
                }
            }
            if (PTS_TAGS) {
                const ptTag = PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1
                })
                if (ptTag) {
                    return ptTag.id
                }
            }
            return ptId
        }

        function getLanguage() {
            const lng = getParamValue('lng')
            if (lng) {
                return lng
            }
            return 'pt'
        }

        function getApiKey() {
            if (PTS_TAGS) {
                const ptTag = PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1 || tag.id === window.ptId
                })
                if (ptTag && ptTag.api) {
                    return ptTag.api
                }
            }
            return 'common'
        }

        function checkBackground() {
            if (window.screenBackgroundColor) {
                if (document.documentElement && document.documentElement.style) {
                    document.documentElement.style.backgroundColor = '#' + window.screenBackgroundColor
                }
                if (document.body && document.body.style) {
                    document.body.style.backgroundColor = '#' + window.screenBackgroundColor
                }
            }
        }

        function getFilteredPacks() {
            try {
                const packId = getParamValue('pack_id')
                if (packId) {
                    return [parseInt(packId)]
                }
                const packIds = getParamValue('pack_ids') || getParamValue('packs')
                if (packIds) {
                    return JSON.parse(packIds).map(function (id) {
                        return parseInt(id)
                    })
                }
            } catch {}
            return null
        }
    },
    updateAuthorization: function (data) {
        const user = data && data.email ? data.email : JSON.parse(process.env.VUE_APP_EMAIL).pt
        const password = data && data.password ? data.password : JSON.parse(process.env.VUE_APP_PASSWORD).pt
        axios.defaults.authorization = 'Basic ' + window.btoa(user + ':' + password)
    },
    refreshEnums: function (enums) {
        try {
            if (window.strings) {
                for (const key in enums) {
                    if (enums[key]) {
                        for (let i = 0; i < enums[key].length; i++) {
                            if (enums[key][i].label) {
                                enums[key][i].label = window.strings[enums[key][i].label] ? window.strings[enums[key][i].label] : enums[key][i].label
                            }
                        }
                    }
                }
            }
        } catch (error) { }
        window.enums = enums
    },
    processResponse: function (response, callback) {
        const self = this
        try {
            const responseData = response && response.request && response.request.response ? JSON.parse(response.request.response) : {
                success: false,
                data: null,
                message: self.getMessageError(response),
            }
            callback({
                success: responseData ? responseData.success : false,
                data: responseData ? responseData.data : null,
                message: responseData ? responseData.message : null,
            })
        } catch (error) {
            callback({
                success: false,
                message: self.getMessageError(),
            })
        }
    },
    getMessageError: function (response) {
        let messageError = window.strings && window.strings['server_connection_failed'] ? window.strings['server_connection_failed'] : 'Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.'
        if (response && response.message && response.message !== 'Network Error' && response.code !== 'ECONNABORTED') {
            messageError = response.message
        }
        return messageError
    },
    getAlertOptions: function (texts) {
        const str = window.strings ? window.strings : {
            'ok': 'Ok',
            'cancel': 'Cancelar'
        }
        return {
            confirmButtonText: texts && texts.confirm ? texts.confirm : str['ok'],
            cancelButtonText: texts && texts.cancel ? texts.cancel : str['cancel']
        }
    },
    getLabel: function (items, value) {
        for (let i = 0; i < items.length; i++) {
            if (items[i].value === value) {
                return items[i].label
            }
        }
    },
    getPaymentPacksCategories: function () {
        const enums = window.enums
        if (enums) {
            return enums.payments_packs_categories
        } else {
            return []
        }
    },
    encodeEmail: function (email) {
        return email.toLowerCase().replace(/ /g, '')
    },
    getFormatDate: function (date) {
        let d = new Date()

        if (date) {
            d = date
        }

        let month = '' + (d.getMonth() + 1)
        let day = '' + d.getDate()
        const year = d.getFullYear()

        if (month.length < 2) {
            month = '0' + month
        }
        if (day.length < 2) {
            day = '0' + day
        }

        return [year, month, day].join('-')
    },
    getDefaultBirthDate: function () {
        let date = new Date()
        date.setFullYear(date.getFullYear() - 18)
        return this.getFormatDate(date)
    },
    refreshAppUrl: function (config) {
        if ((config && config.dev) || window.apiDev) {
            axios.defaults.ptApiUrl = axios.defaults.urls.dev[window.apiKey].base
        }
    },
    subscriptionTypeValidation: function (config) {
        try {
            if (config && config.checkout) {
                window.useCheckout = true
            }
            if (config && config.hotmart) {
                window.useHotmart = true
            }
            if (config && config.viva_wallet) {
                window.useVivaWallet = true
            }
        } catch (error) {}
    },
    setConfigStrings: function (config) {
        if (config.translate) {
            const keys = [
                'title',
                'emptyFailedMessage',
                'subtitle',
                'label',
                'failedMessage',
                'termsFailedMessage',
                'message',
                'info',
                'text',
                'name',
                'parent',
                'title_failed_payment',
                'title_process_payment',
                'title_valid_payment',
                'subtitle_failed_payment',
                'subtitle_process_payment',
                'subtitle_valid_payment',
                'info_failed_payment',
                'info_process_payment',
                'info_valid_payment',
                'promotionalCodeMessage',
            ]
            handleJson(config)
            handleBookingStrings(config)

            function handleJson(src) {
                for (const key in src) {
                    if (keys.indexOf(key) > -1) {
                        src[key] = window.strings[src[key]] ? window.strings[src[key]] : src[key]
                    }
                    if (typeof src[key] === 'object') {
                        handleJson(src[key])
                    }
                }
            }

            function handleBookingStrings(config) {
                try {
                    if (window.bookingScheduleId && config.steps) {
                        config.steps.forEach(step => { 
                            if (step.booking_title) {
                                step.title = window.strings[step.booking_title] ? window.strings[step.booking_title] : step.booking_title
                            }
                            if (step.booking_subtitle) {
                                step.subtitle = window.strings[step.booking_subtitle] ? window.strings[step.booking_subtitle] : step.booking_subtitle
                            }
                            if (step.booking_info) {
                                step.info = window.strings[step.booking_info] ? window.strings[step.booking_info] : step.booking_info
                            }
                        })
                    }
                } catch { }
            }
        }
    },
    toCssLinearGradient: function (colors, direction) {
        if (!colors || !colors.length) {
            return null
        }
        return 'linear-gradient(' + (direction || 'to right') + ', ' + colors.join(', ') + ')'
    },
    applyBackgroundStyle: function (element, solidColor, gradientColors) {
        if (!element || !element.style) {
            return
        }
        const gradient = this.toCssLinearGradient(gradientColors)
        if (gradient) {
            element.style.backgroundImage = gradient
            element.style.backgroundColor = 'transparent'
            return
        }
        if (solidColor || solidColor === '') {
            element.style.backgroundColor = solidColor
        }
    },
    applyInputBorderStyle: function (element, borderColor, gradientColors, fillColor, borderWidth) {
        if (!element || !element.style) {
            return
        }
        const width = borderWidth || 1
        const gradient = this.toCssLinearGradient(gradientColors)
        if (gradient) {
            const fill = fillColor || '#fff'
            element.style.setProperty('border', width + 'px solid transparent', 'important')
            element.style.setProperty('background-color', 'transparent', 'important')
            element.style.setProperty(
                'background-image',
                'linear-gradient(' + fill + ', ' + fill + '), ' + gradient,
                'important',
            )
            element.style.setProperty('background-origin', 'border-box', 'important')
            element.style.setProperty('background-clip', 'padding-box, border-box', 'important')
            return
        }
        if (borderColor) {
            element.style.borderColor = borderColor
        }
        if (borderWidth) {
            element.style.borderWidth = width + 'px'
        }
    },
    getButtonBackgroundStyle: function (solidColor, gradientColors, backgroundImageUrl) {
        const style = {}
        if (backgroundImageUrl) {
            style.backgroundImage = 'url(' + backgroundImageUrl + ')'
            return style
        }
        const gradient = this.toCssLinearGradient(gradientColors)
        if (gradient) {
            style.backgroundImage = gradient
            style.backgroundColor = 'transparent'
            return style
        }
        if (solidColor || solidColor === '') {
            style.backgroundColor = solidColor
        }
        return style
    },
    refreshStyles: function (config, callback) {
        const self = this
        setTimeout(function () {
            const body = document.body
            const inputs = document.getElementsByClassName('v-input__slot')
            const photoButtons = document.getElementsByClassName('app-button-photo')
            const nextButtons = document.getElementsByClassName('app-button-next')
            const backButtons = document.getElementsByClassName('app-button-back')
            const links = document.getElementsByClassName('nav-link')

            if (!config) {
                if (body.style && window.screenBackgroundColor) {
                    body.style.backgroundColor = '#' + window.screenBackgroundColor
                }
                return true
            }

            if (body.style) {
                if (window.screenBackgroundColor) {
                    body.style.backgroundColor = '#' + window.screenBackgroundColor
                } else {
                    body.style.backgroundColor = config.backgroundColor
                }
            }
            if (inputs) {
                for (let i = 0; i < inputs.length; i++) {
                    self.applyInputBorderStyle(
                        inputs[i],
                        config.inputBorderColor,
                        config.inputBorderGradient,
                        config.inputBackgroundColor,
                        config.inputBorderWidth,
                    )
                }
            }
            if (nextButtons) {
                for (let i = 0; i < nextButtons.length; i++) {
                    if (nextButtons[i].style && config.buttons && config.buttons.next) {
                        nextButtons[i].style.color = config.buttons.next.textColor
                        self.applyBackgroundStyle(
                            nextButtons[i],
                            config.buttons.next.backgroundColor,
                            config.buttons.next.backgroundGradient,
                        )
                        if (config.buttons.next.borderRadius && config.buttons.next.borderRadius !== 0) {
                            nextButtons[i].classList.add('radius-inline')
                            nextButtons[i].style.borderRadius = config.buttons.next.borderRadius + 'px'
                        }
                        if (config.buttons.next.height) {
                            nextButtons[i].style.height = config.buttons.next.height
                        }
                    }
                }
            }
            if (backButtons) {
                for (let i = 0; i < backButtons.length; i++) {
                    if (backButtons[i].style && config.buttons && config.buttons.back) {
                        backButtons[i].style.color = config.buttons.back.textColor
                        self.applyBackgroundStyle(
                            backButtons[i],
                            config.buttons.back.backgroundColor,
                            config.buttons.back.backgroundGradient,
                        )
                        if (config.buttons.back.borderRadius && config.buttons.back.borderRadius !== 0) {
                            backButtons[i].classList.add('radius-inline')
                            backButtons[i].style.borderRadius = config.buttons.back.borderRadius + 'px'
                        }
                        if (config.buttons.back.height) {
                            backButtons[i].style.height = config.buttons.back.height
                        }
                    }
                }
            }
            if (photoButtons) {
                for (let i = 0; i < photoButtons.length; i++) {
                    if (photoButtons[i].style) {
                        photoButtons[i].style.borderColor = config.textColor
                        photoButtons[i].style.color = config.textColor
                    }
                }
            }
            if (links) {
                for (let i = 0; i < links.length; i++) {
                    if (links[i].style) {
                        links[i].style.color = config.textColor
                    }
                }
            }
            if (callback) {
                callback()
            }
        })
    },
}
